module.exports = __webpack_public_path__ + "static/2- Jingle Logo Fx Whaou-e743348daba5c4cc805e04802473fd94.mp3";